﻿(function () {

    'use strict';
    var serviceId = 'repository.eir';
    angular
        .module('app.services')
        .factory(serviceId, eir);

    eir.$inject = ['common', 'repository.abstract', '$http'];

    function eir(common, abstractRepository, $http) {

        var config = common.config;
        function Ctor(mgr) {
            this.manager = mgr;
            this.getEquipmentsByNo = getEquipmentsByNo;
            this.getEIRByEqIdEirIdVesselIdVoyageId = getEIRByEqIdEirIdVesselIdVoyageId;
            this.getEirByNo = getEirByNo;
            this.getVesselByName = getVesselByName;
            this.getVoyageByNo = getVoyageByNo;
            this.getLanguageId = getLanguageId;
            this.getOrganizationLogoUrl = getOrganizationLogoUrl;
            this.getEirReportName = getEirReportName;
            this.getEirGTO = getEirGTO;
        }

        abstractRepository.extend(Ctor);
        return Ctor;

        function getEquipmentsByNo(criterio) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'equipment/GetEquipmentsByNoOnlyGTI?criteria=' + criterio + '&applicationCode=' + common.config.applicationCode);
        }

        function getEIRByEqIdEirIdVesselIdVoyageId(criterio) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'eir/GetEIRSearch', criterio);
        }

        function getEirByNo(criterio) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'eir/GetEirListOnlyGTI?criteria=' + criterio);
        }

        function getVesselByName(criterio) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'eir/GetVesselsByName?criteria=' + criterio);
        }

        function getVoyageByNo(criterio) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'eir/GetVoyagesByNo?criteria=' + criterio);
        }

        function getLanguageId() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'eir/GetLanguageId');
        }

        function getOrganizationLogoUrl() {
            var uri = `${config.basePaths.Base_Path_Resources}account/GetOrganizationLogoUrlByCode?organizationCode=${config.organizationCode}`;
            return common.httpGet(uri);
        }

        function getEirReportName() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'eir/GetEirReportName');
        }

        function getEirGTO(eirId) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'eir/GetEirGTO?eirID='+eirId);
        }
    }
})();